import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickActionCardProps {
  title: string;
  description: string;
  icon: string;
  actionText: string;
  actionHref: string;
  variant: 'critical' | 'urgent' | 'important';
}

const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  icon,
  actionText,
  actionHref,
  variant
}) => {
  const variantStyles = {
    critical: 'bg-error/10 border-error hover:shadow-error/20',
    urgent: 'bg-warning/10 border-warning hover:shadow-warning/20',
    important: 'bg-primary/10 border-primary hover:shadow-primary/20'
  };

  const iconColors = {
    critical: 'text-error',
    urgent: 'text-warning',
    important: 'text-primary'
  };

  return (
    <div className={`border-2 rounded-lg p-6 transition-all duration-300 hover:shadow-lg ${variantStyles[variant]}`}>
      <div className="flex items-start space-x-4">
        <div className={`flex-shrink-0 ${iconColors[variant]}`}>
          <Icon name={icon as any} size={32} variant="solid" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-headline font-semibold text-foreground mb-2">{title}</h3>
          <p className="text-muted-foreground mb-4">{description}</p>
          <a
            href={actionHref}
            className="inline-flex items-center space-x-2 text-primary font-semibold hover:underline"
          >
            <span>{actionText}</span>
            <Icon name="ArrowRightIcon" size={16} variant="outline" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default QuickActionCard;